import React from "react";
import { Link } from "react-router-dom";
import { MentisWordmark } from "@/components/MentisMark";
import { RotateCcw } from "lucide-react";

export default function Header({ variant = "landing", onReset }) {
  return (
    <header className="h-16 border-b border-black/[0.08] bg-[#FAF9F7]/85 backdrop-blur-md sticky top-0 z-50">
      <div className="h-full px-5 sm:px-8 flex items-center justify-between max-w-[1600px] mx-auto">
        <a href="https://www.mentogram.com" target="_blank" rel="noreferrer" data-testid="nav-logo"><MentisWordmark /></a>

        {variant === "landing" ? (
          <nav className="flex items-center gap-6 text-sm text-slate-700">
            <a href="https://mentis.mentogram.com/auth/login" target="_blank" rel="noreferrer"
              className="btn-orange rounded-full px-4 py-1.5 text-sm font-semibold text-slate-900" data-testid="nav-signin">Sign In</a>
          </nav>
        ) : (
          <div className="flex items-center gap-4">
            <Link to="/admin" className="text-sm text-slate-700 hover:text-slate-900 transition-colors hidden sm:inline" data-testid="nav-admin">Admin</Link>
            {onReset && (
              <button data-testid="reset-demo-btn" onClick={onReset}
                className="flex items-center gap-1.5 text-xs text-slate-700 hover:text-orange-400 transition-colors border border-black/10 rounded-full px-3 py-1.5">
                <RotateCcw size={13} /> Restart
              </button>
            )}
          </div>
        )}
      </div>
    </header>
  );
}
